import { OrderProductModel } from 'models/order';

export default function getPricePayload(orderProduct: OrderProductModel, newValue) {
  return {
    ...orderProduct,
    price: newValue - orderProduct.optionsPrice
  };
}
